<script setup lang="ts">
import { cardActions } from "@/action/cardActions";
import { cardKey } from "@/components/StickyNote/injectKeys";
import { dropdownKey } from "@/components/ui/DropdownMenu/injectKeys";
import type { Art } from "@/model/session";
import { injectStrict } from "@/utils/vue";

import ArtSelector from "../../../../../ArtSelector/ArtSelector.vue";

const card = injectStrict(cardKey);
const dropdown = injectStrict(dropdownKey);

defineProps<{ selected?: Art; arts: readonly Art[] }>();

const handleArtChange = (art: Art | null) => {
  cardActions.setArt("action-menu", card.id, art?.id ?? null);
  dropdown.close();
};
</script>

<template>
  <ArtSelector :selected :arts @select="handleArtChange" />
</template>
